import { useEffect } from 'react';
import { toast } from 'sonner';
import { productionLogger } from '@/utils';
import { TIMING } from '@/constants';

/**
 * Production health check for product links
 * Validates common link integrity issues
 */
export const ProductLinkHealthCheck = () => {
  

  useEffect(() => {
    const runHealthCheck = () => {
      const issues: string[] = [];

      // Check for common link patterns in the page
      const links = document.querySelectorAll('a[href*="/products/"], a[href*="/shopify-product/"]');
      
      links.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href) return;

        // Check for undefined/null in URLs
        if (href.includes('undefined') || href.includes('null')) {
          issues.push(`Broken link found: ${href}`);
        }

        // Check for empty identifiers
        const parts = href.split('/');
        const identifier = parts[parts.length - 1];
        if (!identifier || identifier.length < 2) {
          issues.push(`Invalid identifier in link: ${href}`);
        }
      });

      // Report issues - ALWAYS log in production for monitoring
      if (issues.length > 0) {
        productionLogger.error('PRODUCTION: Product Link Health Check Issues:', issues);
        
        // Only show toast in development to avoid user disruption
        if (process.env.NODE_ENV === 'development') {
          toast.error(`${issues.length} potential link issues found. Check console for details.`);
        }
      } else {
        // Log successful health check in production for monitoring
        productionLogger.info('Product Link Health Check: All links valid');
      }
    };

    // Run check after DOM is ready
    const timer = setTimeout(runHealthCheck, TIMING.HEALTH_CHECK_DELAY);
    
    return () => clearTimeout(timer);
  }, [toast]);

  return null;
};

export default ProductLinkHealthCheck;